/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ComposerEditableEntity from 'cio/utils/composer/composer-editable-entity';
import { tracked } from '@glimmer/tracking';
import paginate from 'cio/utils/paginate';
import { action } from '@ember/object';
import ObjectModel from 'cio/models/object';
import ObjectTypeModel from 'cio/models/object-type';

interface Args {
  editableEntity: ComposerEditableEntity;
  filterAttribute: string;
  isLiquidInsertionDisabled: boolean;
  insertLiquid: (event: Event | null, liquid: string) => void;
  campaign: Pick<ComposerEditableEntity, 'campaign'>;

  attributes: { label: string; value: any }[];
  currentObject: ObjectModel;
  selectedObjectIndex: number;
  isRelAttrs?: boolean;
  liquidPath?: string[];
  hasReadOnlyPermission: boolean;
}

export default class AttributePanel extends Component<Args> {
  @tracked searchTerm = '';
  @tracked page = 1;

  get matchedAttributes() {
    let trimmedSearchTerm = this.searchTerm.trim().toLowerCase();

    if (trimmedSearchTerm === '') {
      return this.args.attributes;
    }

    return this.args.attributes.filter(({ label }) => label.toLowerCase().includes(trimmedSearchTerm));
  }

  get paginatedAttrs() {
    return paginate(this.matchedAttributes, {
      page: this.page - 1,
      perPage: 5,
    });
  }

  get liquidPath() {
    let { currentObject, liquidPath } = this.args;

    if (liquidPath) {
      return liquidPath;
    }

    if (currentObject == null) {
      return [];
    }

    let { slug } = currentObject.belongsTo('objectType').value() as ObjectTypeModel;

    let path = ['objects', slug, this.args.selectedObjectIndex];

    if (this.args.isRelAttrs === true) {
      path.push('relationship');
    }

    return path;
  }

  @action
  setPage(page: number) {
    this.page = page;
  }

  @action
  setTermAndResetPage(term: string) {
    this.searchTerm = term;
    this.page = 1;
  }
}
